//-----------------------------------------------------
// -slider

import { tree } from "gulp";

//-----------------------------------------------------
export var slider = function() {
	$('.block__slider').each(function(index, el) {
		$(this).find('.slider_box').not('.slick-initialized').slick({
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			respondTo: 'min',
			lazyload: 'ondemand',
			dots: true,
			arrows: false,
			customPaging: function(slider, i) {
				var thumbSrc = $(slider.$slides[i]).find('article').attr('title');
				var color = $(slider.$slides[i]).find('article').attr('data-color');
				return $('<span class="'+color+'">').text(thumbSrc);
			},
			appendDots: $('.dots_box'),
		});
	});
	// $('.logo__list').slick({
	// 	autoSlidesToShow: true,
	// 	variableWidth: true,
	// 	autoplay: true,
	// 	autoplaySpeed: 0,
	// 	speed: 4500,
	// 	pauseOnHover: false,
	// 	cssEase: 'linear',
	// 	arrows: false,

	// 	responsive: [	
	// 		{	
	// 			breakpoint: 1420,	
	// 			settings: {	
	// 			  slidesToShow: 4,	
	// 			  slidesToScroll: 1,	
	// 			}	
	// 		},	
	// 		{	
	// 			breakpoint: 1200,	
	// 			settings: {	
	// 			  slidesToShow: 3,	
	// 			  slidesToScroll: 1,	
	// 			}	
	// 		},	
	// 		{	
	// 		  breakpoint: 1024,	
	// 		  settings: {	
	// 			slidesToShow: 2,	
	// 			slidesToScroll: 1,	
	// 		  }	
	// 		},	
	// 		{	
	// 			breakpoint: 900,	
	// 			settings: {	
	// 			  slidesToShow: 2,	
	// 			  slidesToScroll: 1,	
	// 			}	
	// 		  },	
	// 		{	
	// 		  breakpoint: 600,	
	// 		  settings: {	
	// 			slidesToShow: 1,	
	// 			slidesToScroll: 1,	
	// 			centerMode: true,	
	// 		  }	
	// 		},	
	// 		{	
	// 		  breakpoint: 480,	
	// 		  settings: {	
	// 			slidesToShow: 1,	
	// 			slidesToScroll: 1,	
	// 			centerMode: true,	
	// 		  }	
	// 		}	
	// 	]
    // });

	var swiperComment = new Swiper("#commentSlider", {
		slidesPerView: 'auto',
        centeredSlides: false,
		spaceBetween: 24,
		scrollbar: {
			el: ".swiper-scrollbar",
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			319: {
				slidesPerView: 1.5,
				centeredSlides: true,
			},
			640: {
				slidesPerView: 3.5,
				centeredSlides: true,
			},
			769: {
			  slidesPerView: 'auto',
			  centeredSlides: false,
			},
		},
    });
	
	// swiperComment.on('click', function () {
	// 	swiperComment.slideNext(fu);	
	// });
	
	// function myCallbackfunction(data){
	// 	console.log('haha');
	// 	//console.log(data);
	// }

	var swiperLogo = new Swiper("#logoSlider", {
        loop: true,
        preloadImages: false,
		slidesPerView: 'auto',
		autoplay: {
			delay: 0,
			disableOnInteraction: false
		},
		speed: 4500,
		grabCursor: false,
		spaceBetween: 60,
		centeredSlides: true,
		breakpoints: {
			319: {
				spaceBetween: 40,
				// slidesPerView: 'auto',
			},
			1280: {
				spaceBetween: 60,
				// slidesPerView: 'auto',
			}
		}
    });
}






